import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { useIntl } from 'react-intl';
import { REMOVE_DISTORTION } from './mutations';
import { growlActionSuccess } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import messages from './intl-messages';

const DeactivateDistortion = ({
  sourceAccountId, targetAccountId, distortion, growl, alreadyInUse, fetchData,
}) => {
  const [removeDistortion] = useMutation(REMOVE_DISTORTION);

  const intl = useIntl();
  return (
    <>
      <Button
        type="button"
        className="p-button-secondary"
        icon="pi pi-lock"
        label={intl.formatMessage(messages.remove)}
        disabled={alreadyInUse}
        onClick={async () => {
          await removeDistortion({
            variables: {
              input: {
                sourceAccountId,
                targetAccountId,
                distortion,
              },
            },
          })
            .then(() => {
              growlActionSuccess(growl, intl.formatMessage(messages.removeDistotionSuccess));
              fetchData();
            })
            .catch(() => {
              growl.show({
                severity: 'error',
                detail: intl.formatMessage(messages.removeDistorionError),
                sticky: true,
              });
            });
        }}
      />
    </>
  );
};

DeactivateDistortion.propTypes = {
  sourceAccountId: PropTypes.number.isRequired,
  targetAccountId: PropTypes.number.isRequired,
  distortion: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
  alreadyInUse: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default withGrowl(DeactivateDistortion);
